import React from 'react'
import Reveal from './Reveal'
import SectionHead from './SectionHead'
import news from '../data/news.json'
import { useI18n } from '../i18n/LanguageContext'
import { getLanguage } from '../i18n/languages'

function NewsSection() {
  const { t, lang } = useI18n()
  const dateLocale = getLanguage(lang).dateLocale
  const dateFormat = (iso) => new Intl.DateTimeFormat(dateLocale, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(iso))

  return (
    <section className="section section-alt" id="news" aria-labelledby="news-title">
      <div className="container">
        <SectionHead id="news-title" kicker={t.news.kicker} title={t.news.title} lead={t.news.lead} />
        <Reveal>
          <ul className="news-list">
            {news.items.map((item, index) => {
              const translated = item.title[lang]
              return (
                <li key={item.id} className="news-item">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="news-link"
                    style={{ transitionDelay: `${index * 30}ms` }}
                  >
                    <time dateTime={item.date} className="news-date">{dateFormat(item.date)}</time>
                    <span className="news-title">
                      {translated ?? item.title.bg}
                      {!translated && (
                        <span className="news-untranslated" title={t.news.untranslatedNote}>BG</span>
                      )}
                    </span>
                    <span className="news-cta">{t.news.readMore} ↗</span>
                  </a>
                </li>
              )
            })}
          </ul>
        </Reveal>
        <Reveal delay={120} className="news-foot">
          <a className="text-link" href={news.source} target="_blank" rel="noopener noreferrer">
            {t.news.viewAll}
          </a>
          <p className="news-note">
            {t.news.sourceNote}
            <span className="news-updated">{t.news.updated}: {dateFormat(news.fetchedAt)}</span>
          </p>
        </Reveal>
      </div>
    </section>
  )
}

export default NewsSection
